<p-toast></p-toast>
<app-loader></app-loader>

<div class="global-main-big-table" *ngIf="!loading">

  <!-- Tabla de montos -->
  <ng-container>
    <p-table 
      [value]="table" 
      styleClass="global-table-dashboard-transactions" 
      [scrollable]="true"
      [scrollHeight]="'ml-auto'" 
      [tableStyle]="{ 'min-width' : '20rem', 'min-height': '20rem' }" 
      #dtmontos>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Compra</th>
          <th>Venta</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td style="background-color: #707dbf; color: white;">{{ row.name }}</td>
          <td>{{ formatNumber(row.buy) }}</td>
          <td>{{ formatNumber(row.sell) }}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <!-- Filtros -->
  <div class="container-table">
    <div class="filters">
      <div>
        <span class="p-input-icon-left">
          <i class="pi pi-search" style="font-size: 18px; color: #797979;"></i>
          <input 
            pInputText 
            type="text" 
            (input)="dtTransactions.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Filtrar por:" />
        </span>
      </div>

      <div>
        <span class="p-input-icon-left">
          <i class="pi pi-calendar" style="font-size: 18px; color: #797979; z-index:2;"></i>
          <p-calendar 
            style="margin-left: -1rem; margin-right: 1rem;" 
            styleClass="campo2" 
            [(ngModel)]="rangeDates"
            selectionMode="range" 
            [readonlyInput]="true" 
            placeholder="Fecha/s" 
            [maxDate]="dateTime"
            [icon]="calendarIcon" 
            [dateFormat]="'dd-mm-yy'" 
            (onClose)="applyDateFilter()">
          </p-calendar>
        </span>
      </div>

      <div *ngIf="isFilter">
        <span class="icon">
          <p-button 
            icon="pi pi-filter-slash" 
            styleClass="p-button-filter" 
            (click)="clearFilter()" 
            class="p-button-text">
          </p-button>
        </span>
      </div>
    </div>

    <!-- Tabla de transacciones -->
    <p-table 
      id="tableTransactions"
      #dtTransactions
      [value]="isFilter ? filteredData : transactions"
      [tableStyle]="{ 'min-width': '25rem' }" 
      [paginator]="true"
      [rows]="rowsPerPage" 
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[50, 100]" 
      (onPage)="onPageChange($event)"
      [loading]="loading" 
      [scrollable]="true" 
      [first]="first" 
      scrollHeight="400px" 
      [sortField]="'date'" 
      [sortOrder]="-1"
      frozenHeader="true"
      [globalFilterFields]="[
        'price','mount','pair.currencyOrigin.name','pair.name', 
        'point_of_sell.name', 'date', 'type_transaction.name', 'customer.name'
      ]"
      selectionMode="single"
      autocomplete="off"
      class="global-table">

      <ng-template pTemplate="header">
        <tr>
          <th>Fechas</th>
          <th>Hora</th>
          <th>Transacción</th>
          <th>Divisas</th>
          <th>Cantidad</th>
          <th>Precio</th>
          <th>Monto</th>
          <th>Cliente</th>
          <th>Punto de cambio</th>
          <th *ngIf="canEdit">Acciones</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-transaction let-i="rowIndex">
        <tr>
          <td>{{ formatDateOfViuwToString(transaction.date) }}</td>
          <td>{{ formatHourOfTransaction(transaction.date) }}</td>
          <td>{{ transaction.type_transaction.name }}</td>
          <td>{{ transaction.pair.name }}</td>
          <td>{{ formatNumber(transaction.quantity) }}</td>
          <td>{{ formatNumber(transaction.price) }}</td>
          <td>{{ formatNumber(transaction.mount) }}</td>
          <td>{{ transaction.customer.name }}</td>
          <td>{{ transaction.point_of_sell.name }}</td>
          <td *ngIf="canEdit">
            <div class="optionsButtons">
              <button 
                pButton 
                (click)="deletetransaction(transaction)" 
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-button-text">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>
